import { createFeature } from '@ngrx/store';
import { reducer } from './tracking-sheet.reducer';

export const TrackingSheetFeature = createFeature({
  name: 'trackingSheet',
  reducer,
});
